import { render, staticRenderFns } from "./BlockHero.vue?vue&type=template&id=ee5ba6d4&scoped=true&"
import script from "./BlockHero.vue?vue&type=script&lang=js&"
export * from "./BlockHero.vue?vue&type=script&lang=js&"
import style0 from "./BlockHero.vue?vue&type=style&index=0&id=ee5ba6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5ba6d4",
  null
  
)

export default component.exports